import React, { ReactNode } from "react";

import ComponentNames from "../../../../../../resources/generated/components.json";
import { ComponentKeys } from "../../../../../../core/services/componentService/component-service";

const getCustomDisableReason = (component): ReactNode | null => {
    if (component.id === ComponentNames.Sherlock[ComponentKeys.ComponentName]) {
        return (
            <React.Fragment>
                Sherlock is currently accessible from the <b>Sensitive Data Governance</b> section in the left menu.{" "}
                <br /> You can click{" "}
                <a href="/#/sherlock-ai/discovery" style={{ color: "#00baff" }}>
                    here
                </a>{" "}
                to access Sherlock.
            </React.Fragment>
        );
    }
    return null;
};

export { getCustomDisableReason };
